import Ajax from '../../../../util/ajax';
export function zigbeeStopWithOnOff(nid, eid) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/stop-with-on-off';
        ajax.post(url);
    };
}
